export default function GiviLogo({ className = "w-64" }) {
  return (
    <img
      src="/assets/givi-logo.png"
      alt="GIVI — Make Every Moment Yours"
      data-testid="brand-logo"
      draggable="false"
      className={`select-none ${className}`}
    />
  );
}
